<template>
  <div class='wrap'>
    <el-container class="container">
      <el-aside width="200px">
        <sidebar/>
      </el-aside>
      <el-main class="main">
        <div class="content">
          <router-view :key="new Date().getTime()"/>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import sidebar from './sidebar'
export default {
  data() {
    return {
      
    }
  },
  components: {
    sidebar
  },
  computed: {},
  watch: {},
  created() {
    this.$store.dispatch('getDingConfig');
    this.$store.dispatch('getType');
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.wrap{
  position: absolute;
  width: 100%;
  min-height: 100%;
  .container{
    position: absolute;
    width: 100%;
    min-height: 100%;
    .main{
      background: #f8f8f8;
      .content{
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) 
      }
    }
  }
}
</style>